import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './AccessoriesProducts.css';
import ProductModal from './ProductModal';
import wp1_1 from './assets/women/wp1_1.JPG';
import wp1_2 from './assets/women/wp1_2.JPG';
import wp1_3 from './assets/women/wp1_3.JPG';
import wp2_1 from './assets/women/wp2_1.jpg';
import wp2_2 from './assets/women/wp2_2.jpg';
import wp2_3 from './assets/women/wp2_3.jpg';
import wp2_4 from './assets/women/wp2_4.jpg';
import wp3_1 from './assets/women/wp3_1.jpg';
import wp3_2 from './assets/women/wp3_2.jpg';
import wp3_3 from './assets/women/wp3_3.jpg';
import wp4_1 from './assets/women/wp4_1.jpg';
import wp4_2 from './assets/women/wp4_2.jpg';
import wp4_3 from './assets/women/wp4_3.jpg';
import wp5_1 from './assets/women/wp5_1.jpg';
import wp5_2 from './assets/women/wp5_2.jpg';
import wp6_1 from './assets/women/wp6_1.jpg';
import wp6_2 from './assets/women/wp6_2.jpg';
import ap2_1 from './assets/accessories/ap2_1.JPG';
import ap2_2 from './assets/accessories/ap2_2.JPG';
import img4463_1 from './assets/women/0M1A4463.jpg';
import img4463_2 from './assets/women/0M1A4464.jpg';
import img4466_1 from './assets/women/0M1A4466.jpg';
import img4466_2 from './assets/women/0M1A4467.jpg';
import img4466_3 from './assets/women/0M1A4469.jpg';
import img4473_1 from './assets/women/0M1A4473.jpg';
import img4473_2 from './assets/women/0M1A4474.jpg';
import img4481_1 from './assets/women/0M1A4481.jpg';
import img4481_2 from './assets/women/0M1A4482.jpg';
import img4664_1 from './assets/women/0M1A4664.jpg';
import img4664_2 from './assets/women/0M1A4665.jpg';
import img4664_3 from './assets/women/0M1A4666.jpg';
import img4688_1 from './assets/women/0M1A4688.jpg';
import img4688_2 from './assets/women/0M1A4690.jpg';
import img7886_1 from './assets/women/0M1A7886.jpg';
import img7886_2 from './assets/women/0M1A7889.jpg';
import img7886_3 from './assets/women/0M1A7892.jpg';
import imgAM240503_1 from './assets/women/AM24-0503_(4).jpg';
import imgAM240503_2 from './assets/women/AM24-0503_(5).jpg';
import imgAM240503_3 from './assets/women/AM24-0503_(6).jpg';
import imgAN240806_1 from './assets/women/AN-240806_(4).jpg';
import imgAN240806_2 from './assets/women/AN-240806_(6).jpg';
import imgJ1138_1 from './assets/women/J - 1138 (1).jpg';
import imgJ1138_2 from './assets/women/J - 1138 (2).jpg';
import imgJ19322_1 from './assets/women/J - 19322 (1).jpg';
import imgJ19322_2 from './assets/women/J - 19322 (2).jpg';
import imgJ19322_3 from './assets/women/J - 19322 (3).jpg';
import imgJ19322_4 from './assets/women/J - 19322 (4).jpg';
import imgJ4467_1 from './assets/women/J - 4467 (1).jpg';
import imgJ4467_2 from './assets/women/J - 4467 (2).jpg';
import imgJ4467_3 from './assets/women/J - 4467 (3).jpg';
import imgMsgr_1 from './assets/women/Massenger Bag.jpg';
import imgMsgr_2 from './assets/women/messenger bag.jpg';
import imgRN2019_1 from './assets/women/RN-2019_(3).jpg';
import imgRN2019_2 from './assets/women/RN-2019_(5).jpg';
import img18172_1 from './assets/women/00018172_20_b_1800x1800.jpeg';
import img18172_2 from './assets/women/00018172_20_b_2800x1800.jpg';
import imgRN2019_3 from './assets/women/RN-2019_(8).jpg';
import imgRN2019_4 from './assets/women/RN-2019_(9).jpg';

const WomenProducts = () => {
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openProduct = (name, image) => {
    setSelectedProduct({ name, image, category: "WOMEN'S COLLECTION" });
    setIsModalOpen(true);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const createCard = (images, title) => (
    <div 
      className="card" 
      onClick={(e) => {
        if (e.target.closest('.slick-arrow') || e.target.closest('.slick-dots')) {
          return;
        }
        openProduct(title, images);
      }}
    >
      {images.length > 1 ? (
        <Slider {...settings}>
          {images.map((img, index) => (
            <div key={index}><img src={img} alt={`${title} - ${index + 1}`} /></div>
          ))}
        </Slider>
      ) : (
        <div><img src={images[0]} alt={`${title} - 1`} /></div>
      )}
      <h3>{title}</h3>
    </div>
  );


  return (
    <div className="category-container">
      <h2>Women's Products</h2>
      <div className="card-container">
        {createCard([wp1_1, wp1_2, wp1_3], "AN07092")}
        {createCard([wp2_1, wp2_2, wp2_3, wp2_4], "ARI07016")}
        {createCard([wp3_1, wp3_2, wp3_3], "ARI04167")}
        {createCard([wp5_1, wp5_2], "ARI04214e")}
        {createCard([wp4_1, wp4_2, wp4_3], "ARI04185e")}
        {createCard([wp6_1, wp6_2], "111")}
        {createCard([ap2_1, ap2_2], "BLACK 001")}
        {createCard([img4463_2,img4463_1 ,img4466_1, img4466_2, img4466_3], "Model 4463")}
        {createCard([img4473_1, img4473_2], "Model 4473")}
        {createCard([img4481_2, img4481_1], "Model 4481")}
        {createCard([img4664_2,img4664_1, img4664_3], "Model 4664")}
        {createCard([img4688_1, img4688_2], "Model 4688")}
        {createCard([img7886_1, img7886_2, img7886_3], "Model 7886")}
        {createCard([imgAM240503_1, imgAM240503_2, imgAM240503_3], "AM24-0503")}
        {createCard([imgAN240806_1, imgAN240806_2], "AN-240806")}
        {createCard([imgJ1138_1, imgJ1138_2], "J-1138")}
        {createCard([imgJ19322_1, imgJ19322_2, imgJ19322_3, imgJ19322_4], "J-19322")}
        {createCard([imgJ4467_1, imgJ4467_2, imgJ4467_3], "J-4467")}
        {createCard([imgMsgr_1, imgMsgr_2], "Messenger Bag")}
        {createCard([imgRN2019_1, imgRN2019_2, imgRN2019_3, imgRN2019_4], "RN-2019")}
        {createCard([img18172_1, img18172_2], "18172_20")}
      </div>
      <ProductModal 
        product={selectedProduct} 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default WomenProducts;
